const items = [
  "Business Websites", "Quote Request Websites", "Landing Pages", "Website Redesigns",
  "Mobile Responsive Design", "Custom Website Development", "We Launch It & Take Care of It",
];

export const Marquee = () => (
  <div className="marquee relative border-y border-white/[0.06] bg-ink2/60 py-5 overflow-hidden" aria-hidden="true">
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent z-10" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent z-10" />
    <div className="marquee-track">
      {[...items, ...items].map((t, i) => (
        <span key={i} className="flex items-center gap-8 pr-8 font-display text-lg sm:text-xl text-slate-500 whitespace-nowrap">
          {t}
          <span className="h-1.5 w-1.5 rounded-full bg-gradient-to-r from-indigo-400 to-violet-400 shadow-[0_0_12px_rgba(139,92,246,0.9)]" />
        </span>
      ))}
    </div>
  </div>
);
